import { StarIcon } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { RateOrderEditorRenderer } from "./editor";
import { RateOrderEmailRenderer } from "./email";
import { RateOrderEmailPanelRenderer } from "./email-panel";
import type { RateOrderBlockProps } from "./types";
import RateOrderWeb from "./web";
import { RateOrderWebEditor } from "./web-editor";

export default registerBlock<RateOrderBlockProps>({
  type: "rate-order",
  name: "editorBlocksLibrary.blocks.rate-order.title",
  description: "editorBlocksLibrary.blocks.rate-order.description",
  Icon: StarIcon,
  category: BlockCategory.TRACKING,
  components: {
    email: {
      component: RateOrderEmailRenderer,
      editor: {
        component: RateOrderEditorRenderer,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: RateOrderEmailPanelRenderer,
      },
      compatibility: {
        rowBlock: false,
      },
    },
    web: {
      component: RateOrderWeb,
      editor: {
        component: RateOrderWebEditor,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: RateOrderEmailPanelRenderer,
      },
      compatibility: {
        rowBlock: false,
      },
    },
  },
});

export type { RateOrderBlockProps };
